import React from 'react';
import { StickyHeader } from './components/StickyHeader';
import { Hero } from './components/Hero';
import { StatsStrip } from './components/StatsStrip';
import { TestimonialRow } from './components/TestimonialRow';
import { ProblemAgitation } from './components/ProblemAgitation';
import { ProductIntro } from './components/ProductIntro';
import { ThreeTomos } from './components/ThreeTomos';
import { ThreeBonus } from './components/ThreeBonus';
import { Countdown } from './components/Countdown';
import { Pricing } from './components/Pricing';
import { ManualComparison } from './components/ManualComparison';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Footer } from './components/Footer';
export function App() {
  const firstTestimonials = [{
    initials: 'MG',
    name: 'Marcela G.',
    location: 'Monotributista, Buenos Aires',
    quote: 'La planilla me avisa cuando me acerco al tope. No puedo creer que no lo tenía antes.'
  }, {
    initials: 'LP',
    name: 'Lucas P.',
    location: 'Freelancer, Rosario',
    quote: 'Recuperé el SIRCREB que me retenían mal. Valió mil veces lo que pagué.'
  }, {
    initials: 'RM',
    name: 'Roberto M.',
    location: 'Comerciante, Córdoba',
    quote: 'Llegué con una notificación de AFIP en la mano. El Bonus 2 me dio la nota exacta para resolverlo.'
  }];
  const secondTestimonials = [{
    initials: 'CR',
    name: 'Cecilia R.',
    location: 'Mendoza',
    quote: 'El Sistema de 3 Cuentas me cambió la vida. Ahora tengo todo separado y duermo tranquila.'
  }, {
    initials: 'SC',
    name: 'Sofía C.',
    location: 'La Plata',
    quote: 'Me habían retenido SIRCREB mal durante 8 meses. Tramité la exclusión y me devolvieron todo. Recuperé más de lo que pagué por el Kit.'
  }, {
    initials: 'PA',
    name: 'Pablo A.',
    location: 'Neuquén',
    quote: 'Tenía el 94% de mi tope facturado y no lo sabía. La Planilla me lo mostró a tiempo. Me salvé de una exclusión de oficio.'
  }];
  return <div className="min-h-screen w-full bg-[#FAF7F2] text-[#1A1A1A]" data-id="element-0">
      <StickyHeader data-id="element-1" />
      <Hero data-id="element-2" />
      <StatsStrip data-id="element-3" />
      <TestimonialRow testimonials={firstTestimonials} data-id="element-4" />
      <ProblemAgitation data-id="element-5" />
      <ProductIntro data-id="element-6" />
      <ThreeTomos data-id="element-7" />
      <ThreeBonus data-id="element-8" />
      <Countdown warning="⚠️ Después sube $5.000 ARS. No vuelve." data-id="element-9" />
      <Pricing data-id="element-10" />
      <ManualComparison data-id="element-11" />
      <TestimonialRow testimonials={secondTestimonials} title="❤️ MÁS ARGENTINOS QUE YA LO TIENEN" data-id="element-12" />
      <FAQ data-id="element-13" />
      <CostComparison data-id="element-14" />
      <div className="bg-[#FAF5EC] border-t border-[#EAE5DC]" data-id="element-15">
        <Countdown title="⏰ ÚLTIMA OPORTUNIDAD" data-id="element-16" />
        <Pricing title="" compact={true} data-id="element-17" />
        <div className="text-center py-8 px-4" data-id="element-18">
          <p className="text-[#6B7280]" data-id="element-19">
            🔒 Pago 100% seguro | ⚡ Acceso en 5 minutos | 💳 Mercado Pago |
            Tarjeta | Transferencia
          </p>
        </div>
      </div>
      <Footer data-id="element-20" />
    </div>;
}